/**
 * Create the store with dynamic reducers
 */

import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import { persistStore } from 'redux-persist';
import createReducer from './reducers';

export const exportedStore = {
  store: null,
  persistor: null,
  dispatch: () => null,
  getState: () => ({})
};

export default function configureStore(initialState = {}, history) {
  const composeEnhancers = composeWithDevTools({trace: true});

  const sagaMiddleware = createSagaMiddleware();

  // Create the store with two middlewares
  // 1. sagaMiddleware: Makes redux-sagas work
  // 2. routerMiddleware: Syncs the location/URL path to the state
  const middleware = [sagaMiddleware, routerMiddleware(history)];

  const enhancers = [applyMiddleware(...middleware)];

  const store = createStore(createReducer(), initialState, composeEnhancers(...enhancers));

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  const persistor = persistStore(store);

  exportedStore.store = store;
  exportedStore.persistor = persistor;
  exportedStore.dispatch = store.dispatch;
  exportedStore.getState = store.getState;

  return { store, persistor };
}
